import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { MenuItem } from '@src/common/components/Menu';
import { useToast } from '@src/common/hooks/useToast';
import {
  actionIconStyle,
  menuItemStyle,
} from '@src/orders/components/permitList/PermitActions/PermitActionsStyles';
import {
  DuplicationTrigger,
  useDuplicatePermitAsNew,
} from '@src/orders/hooks/useDuplicatePermitAsNew';
import { useRefreshOrder } from '@src/orders/hooks/useRefreshOrder';
import { useRefreshOrders } from '@src/orders/hooks/useRefreshOrders';
import type { ComponentPropsWithoutRef } from 'react';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

interface Props extends ComponentPropsWithoutRef<typeof MenuItem> {
  permitId: string;
  orderId: string;
}
export const AmendPermit = forwardRef<HTMLLIElement, Props>(
  ({ permitId, orderId, ...menuItemProps }, ref) => {
    const { t } = useTranslation();
    const { refreshOrders } = useRefreshOrders();
    const { refreshOrder } = useRefreshOrder({ id: orderId });
    const { showSuccessToast, showErrorToast } = useToast();
    const { duplicateAsNew } = useDuplicatePermitAsNew({
      permitApplicationId: permitId,
      onSuccess: () => {
        showSuccessToast(t('permitApplication.amendWithSuccess'));
        refreshOrder();
        refreshOrders();
      },
      onError: () => showErrorToast(t('permitApplication.amendWithError')),
    });

    const handleAmendPermitClick = () => {
      duplicateAsNew({
        trigger: DuplicationTrigger.AMEND,
      });
    };
    return (
      <>
        <MenuItem
          {...menuItemProps}
          ref={ref}
          className={menuItemStyle}
          onClick={() => handleAmendPermitClick()}
        >
          <EditOutlinedIcon style={actionIconStyle} />
          {t('permitApplication.amend')}
        </MenuItem>
      </>
    );
  },
);
